var map = {
	"./1.jpg": "3c51",
	"./10.jpg": "3563",
	"./2.jpg": "804f",
	"./3.jpg": "0c96",
	"./4.jpg": "a2b4",
	"./5.jpg": "83e1",
	"./6.jpg": "862f",
	"./7.jpg": "6471",
	"./8.jpg": "5ffc",
	"./9.jpg": "53d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f791";